// extracted by mini-css-extract-plugin
module.exports = {"container":"_2IDBXp","container--dark":"_2dQ5k7 mz-dark-mode"};